module.exports = __webpack_public_path__ + "static/img/img10.467a5596.png";